import api from "./core";

const basePath = "api/core/Users";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter) {
    return api.post(`${basePath}`, filter);
  },
  queryImproved() {
    return api.post(`${basePath}/QueryImproved`);
  },
  getFilteredUsers() {
    return api.post(`${basePath}/GetFilteredUsers`);
  },
  getFilteredManagers(filter) {
    return api.post(`${basePath}/GetFilteredManagers`, filter);
  },
  getMinimalUsers(filter = {}) {
    return api.post(`${basePath}/GetMinimalUsers`, filter);
  },
  getUserServices() {
    return api.post(`${basePath}/GetUserServices`);
  },
  findAllProviders(filter) {
    return api.post(`${basePath}/FindAllProviders`, filter, {
      "Hide-Loading": true
    });
  },
  getFilteredProviders(filter) {
    return api.post(`${basePath}/GetFilteredProviders`, filter);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  updateCurrentUserProfile(data) {
    return api.patch(`${basePath}/EditProfile`, data);
  },
  changeCurrentUserPassword(data) {
    return api.patch(`${basePath}/ChangePassword`, data);
  },
  updateCurrentUserSignature(data) {
    return api.patch(`${basePath}/SetSignature`, data);
  },
  changeUserPassword(id, data) {
    return api.patch(`${basePath}/SetPassword/${id}`, data);
  },
  agreeToEULA(id) {
    return api.post(`${basePath}/AgreeToEULA/${id}`);
  },
  getCredentials() {
    return api.post(`${basePath}/Credentials`);
  },
  getSupervisees(id) {
    return api.get(`${basePath}/FindSupervisees/${id}`);
  },
  getAllUsers() {
    return api.get(`${basePath}/GetAllUsers`);
  },
  findAccessToLocations(id) {
    return api.get(`${basePath}/AccessToLocations/${id}`);
  },
  getProviderPlaceOfServices() {
    return api.get(`${basePath}/GetProviderPlaceOfServices`);
  }
};
